module.exports = __webpack_public_path__ + "img/otf.a7bad476.svg";